
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opera-shared-page/header",
      function () {
        return require("private-next-pages/opera-shared-page/header.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opera-shared-page/header"])
      });
    }
  